import { datadogRum } from "@datadog/browser-rum";
import { useEffect } from "react";

import { useCurrentUser } from "@src/hooks/queries/account";
import { useRole } from "@src/hooks/queries/account-selectors";

export function useDatadogRumUserSync() {
  const currentUser = useCurrentUser();
  const role = useRole();

  useEffect(() => {
    if (currentUser) {
      datadogRum.setUser({
        id: currentUser.userId,
        role,
        organizationCode: currentUser.organizationCode,
      });
    } else {
      datadogRum.clearUser();
    }
  }, [currentUser, role]);
}
